import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109.8c28.167 0 51-22.834 51-51 0-28.167-22.833-51-51-51-28.166 0-51 22.833-51 51 0 28.166 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M64 113c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#ACB8C3"
      d="M96.4 47a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M8.47 75.86a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M30.443 98.553c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.58.59-1.53 0-2.12l-3.94-3.94 3.93-3.93c.59-.58.58-1.53 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.93 3.93-3.93-3.93c-.58-.59-1.53-.58-2.12 0a1.49 1.49 0 0 0 0 2.12l3.93 3.93-3.94 3.94a1.49 1.49 0 0 0 0 2.12M76.5 25.13c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.56h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H79.5V11c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.56c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.56z"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      d="M96.03 99.14c-.58 0-1.15-.22-1.59-.66l-14.6-14.6c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l14.6 14.6c.88.88.88 2.3 0 3.18-.44.44-1.01.66-1.59.66"
    />
    <path
      fill="#ACB8C3"
      d="m89.61 81.66-8.81 8.81c-4.11 4.11-10.79 4.11-14.9 0L53.45 78.02l23.71-23.71 12.45 12.45c4.11 4.11 4.11 10.79 0 14.9"
    />
    <path
      fill="#8F9BA8"
      d="M81.72 51.25c-.88-.88-2.3-.88-3.18 0l-7.34 7.34-6.46-6.46c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18l6.46 6.46-7.47 7.47-6.46-6.46c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18l6.46 6.46-6.99 6.99a2.25 2.25 0 0 0 1.59 3.84c.57 0 1.15-.22 1.59-.66l28.16-28.16c.88-.88.88-2.3 0-3.18M34.56 37.55c-.58 0-1.15-.22-1.59-.66l-14.6-14.6c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l14.6 14.6a2.25 2.25 0 0 1-1.59 3.84"
    />
    <path
      fill="#C7D0D9"
      d="m26.3 36.03 8.99-8.99c4.06-4.06 10.66-4.06 14.72 0l12.54 12.54-23.71 23.71L26.3 50.75c-4.06-4.06-4.06-10.66 0-14.72"
    />
    <path
      fill="#8F9BA8"
      d="M35.8 66.95c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18l28.16-28.16c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18L37.39 66.29c-.44.44-1.02.66-1.59.66"
    />
  </svg>
);
const SvgEnrichedIconIntegrationsGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconIntegrationsGreyscale);
export default Memo;
